import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  blueTextColor: () => {
    return { color: "#f94902", fontWeight: 900 };
  },

  headingStyle: {
    fontSize: "24px",
    textAlign: "center",
  },
  addTopMargin: {
    marginTop: "20px",
  },
}));

type DisplayResultProps = {
  result: any;
  unit?: string;
  text1?: string;
  text2?: string;
  className?: any;
};

export const DisplayResult: FC<DisplayResultProps> = ({ result, unit, text1, text2, className }) => {
  const classes = useStyles();
  return (
    <div className={classes.addTopMargin}>
      <div className={classes.headingStyle}>
        <span>{text1}</span>
        <span className={`${classes.blueTextColor} ${className ? className : ''}`}>{` ${result} `}</span>
        <span>{unit}</span>
        {text2 ? <span>{text2}</span> : null}
      </div>
    </div>
  );
};
